import { Link } from "react-router-dom";
import { Compass, Phone } from "lucide-react";
import Seo from "../components/Seo";
import { LOCATIONS, NAV_LINKS } from "../lib/content";

const WB = LOCATIONS["west-branch"];

export default function NotFound() {
  return (
    <>
      <Seo
        title="Page Not Found | West Branch Marina"
        description="That page has drifted off. Head back to the marina to find boat rentals, lake information and contact details."
        path="/404"
      />

      <section className="relative isolate overflow-hidden bg-navy grain">
        <img
          src="/images/lake_aerial.jpeg"
          alt="Aerial view of the lake at West Branch State Park"
          width={1264}
          height={848}
          className="absolute inset-0 h-full w-full object-cover opacity-30"
        />
        <div className="absolute inset-0 hero-scrim" />
        <div className="relative mx-auto max-w-3xl px-5 lg:px-10 pt-32 pb-24 lg:pt-48 lg:pb-36 text-center">
          <Compass className="mx-auto h-12 w-12 text-ember" aria-hidden="true" />
          <p className="eyebrow mt-6 text-lake">Error 404</p>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white">
            This page has drifted off
          </h1>
          <p className="mx-auto mt-5 max-w-xl text-base md:text-lg text-white/85">
            We couldn't find what you were looking for. Let's get you back to the dock.
          </p>

          <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/"
              data-testid="notfound-home-link"
              className="inline-flex items-center rounded-full bg-ember px-7 py-3.5 font-bold text-white transition-colors hover:bg-ember-hover"
            >
              Back to home
            </Link>
            <Link
              to="/boat-rentals"
              data-testid="notfound-rentals-link"
              className="inline-flex items-center rounded-full border border-white/30 px-7 py-3.5 font-bold text-white transition-colors hover:bg-white/10"
            >
              Browse boat rentals
            </Link>
          </div>

          <nav aria-label="Helpful links" className="mt-12">
            <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`notfound-link-${l.to.replace(/\//g, "-").replace(/^-/, "")}`}
                    className="text-sm font-semibold text-white/70 hover:text-ember transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <a
            href={WB.phoneHref}
            data-testid="notfound-call-link"
            className="mt-10 inline-flex items-center gap-2 text-sm font-bold text-white/80 hover:text-white transition-colors"
          >
            <Phone className="h-4 w-4" aria-hidden="true" />
            Or call {WB.phone}
          </a>
        </div>
      </section>
    </>
  );
}
